import { Injectable } from '@angular/core';
import { ModifierItem } from '../../components/modifier-list/modifier-item.interface';
import { MenuPrice } from '../../api/v1/models';

@Injectable({ providedIn: 'root' })
export class PriceCalculationService {

  /**
   * Получить цену товара/модификатора для конкретного outlet
   */
  getPriceByOutletId(prices: MenuPrice[], outletId: number): number {
    return prices.find(price => price.storeId === outletId)?.price ?? 0;
  }

  /**
   * Рассчитать общую стоимость модификаторов с учетом бесплатного количества
   */
  getModifiersPrice(modifiers: ModifierItem[], outletId: number): number {
    return modifiers.reduce((totalSum, modifier) => {
      if (!modifier.prices) { return totalSum; }
      if (modifier.freeQuantity >= modifier.quantity) { return totalSum; }

      const modifierPrice = this.getPriceByOutletId(modifier.prices, outletId);
      totalSum += modifierPrice * (modifier.quantity - modifier.freeQuantity);

      return totalSum;
    }, 0);
  }

  /**
   * Рассчитать общую стоимость товара с модификаторами
   */
  getItemTotal(prices: MenuPrice[], modifiers: ModifierItem[], count: number, outletId: number): number {
    const itemPrice = this.getPriceByOutletId(prices, outletId);
    const modifiersTotalPrice = this.getModifiersPrice(modifiers, outletId);
    return (itemPrice + modifiersTotalPrice) * count;
  }
}
